
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HeaderBar extends Vue {
  goToInfo(): void {
    this.$router.push({ name: "about" });
  }
}
